/*
 * Bascule « Voir plus / Voir moins » de la description produit.
 *
 * Pattern WAI-ARIA Disclosure : un <button aria-expanded aria-controls> pilote
 * le repli purement présentationnel de la description (CSS max-height + fondu).
 * Aucun mot n'est coupé (le texte habille naturellement), la mise en forme HTML
 * est préservée, et le contenu complet reste dans le DOM (SEO).
 *
 * Le bouton n'est révélé que si le contenu déborde réellement de l'aperçu replié ;
 * sinon le repli est retiré et le bouton reste masqué. Amélioration progressive :
 * sans JavaScript, le contenu complet est affiché (cf. <noscript> du snippet).
 *
 * Convention IIFE alignée sur assets/product-options-collapse.js.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Marge anti sous-pixel : évite d'afficher le bouton pour un débordement d'1 px.
  var OVERFLOW_TOLERANCE = 4;

  function init(wrapper) {
    var content = wrapper.querySelector('[data-product-description-content]');
    var toggle = wrapper.querySelector('[data-product-description-toggle]');
    if (!content || !toggle) return;

    var label = toggle.querySelector('[data-product-description-toggle-label]') || toggle;
    var labelMore = toggle.getAttribute('data-label-more') || label.textContent || '';
    var labelLess = toggle.getAttribute('data-label-less') || labelMore;
    var userExpanded = false;

    function setExpanded(expanded) {
      wrapper.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? labelLess : labelMore;
    }

    // Le débordement doit se mesurer en état replié : une fois `is-expanded`
    // posé, max-height:none rend clientHeight == scrollHeight. On replie donc
    // le temps de la mesure (lecture synchrone : aucun repaint intermédiaire).
    function overflows() {
      var wasExpanded = wrapper.classList.contains('is-expanded');
      if (wasExpanded) wrapper.classList.remove('is-expanded');
      var result = content.scrollHeight - content.clientHeight > OVERFLOW_TOLERANCE;
      if (wasExpanded) wrapper.classList.add('is-expanded');
      return result;
    }

    function applyState() {
      if (userExpanded) {
        setExpanded(true);
        toggle.hidden = false;
        return;
      }
      if (overflows()) {
        setExpanded(false);   // aperçu replié + fondu + bouton « Voir plus »
        toggle.hidden = false;
      } else {
        setExpanded(true);    // tout tient : affichage complet, fondu masqué
        toggle.hidden = true; // rien à révéler
      }
    }

    toggle.addEventListener('click', function () {
      userExpanded = !wrapper.classList.contains('is-expanded');
      setExpanded(userExpanded);
    });

    // Le reflow (redimensionnement, polices/images chargées tardivement) peut
    // changer le débordement : on réévalue tant que l'utilisateur n'a pas
    // explicitement déplié.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyState, 150);
    });
    window.addEventListener('load', applyState);

    applyState();
  }

  ready(function () {
    document.querySelectorAll('[data-product-description]').forEach(init);
  });
})();
